import PropTypes from 'prop-types';
import './GlobalStyles.scss';

const GlobalStyles = (props: any) => {
  return props.children;
};

export default GlobalStyles;
